/**
 * OrbDocCoreConceptsStandardLibraryENOrbDocCoreConceptsStandardLibraryENPage
 *
 * Page component for OrbDocCoreConceptsStandardLibraryENOrbDocCoreConceptsStandardLibraryENPage
 * Path: /docs/core-concepts/standard-library
 *
 * @generated from schema
 */

import React from 'react';
import { useLocation } from 'react-router-dom';
import type { EventPayload } from '@almadar/core';
import { OrbDocCoreConceptsStandardLibraryENDocScreenView as __OrbDocCoreConceptsStandardLibraryENDocScreenView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryENDocScreenView';
import { OrbDocCoreConceptsStandardLibraryENDocAnalyticsView as __OrbDocCoreConceptsStandardLibraryENDocAnalyticsView } from '@/components/traits/OrbDocCoreConceptsStandardLibraryENDocAnalyticsView';
import { VStack, UISlotComponent } from '@almadar/ui/components';
import { usePageHead } from '@almadar/ui/hooks';

interface OrbDocCoreConceptsStandardLibraryENOrbDocCoreConceptsStandardLibraryENPageProps {
  // Add any page-level props here
}

export function OrbDocCoreConceptsStandardLibraryENOrbDocCoreConceptsStandardLibraryENPage(_props: OrbDocCoreConceptsStandardLibraryENOrbDocCoreConceptsStandardLibraryENPageProps) {
  const __location = useLocation();
  const __navState = (__location.state ?? {}) as EventPayload;

  usePageHead({ "title":"The standard library","description":"Hundreds of behaviors, from lists and forms to games and learning instruments, ready to import and bind.","access":"public","indexing":"index","origin":"https://orb.almadar.io","siteName":"Orb","alternates":[{"locale":"en","path":"/docs/core-concepts/standard-library"},{"locale":"ar","path":"/ar/docs/core-concepts/standard-library"},{"locale":"sl","path":"/sl/docs/core-concepts/standard-library"}],"defaultLocale":"en", path: __location.pathname });

  return (
    <>
      <UISlotComponent slot="main">
        <VStack gap="lg" className="w-full">
          <__OrbDocCoreConceptsStandardLibraryENDocScreenView config={{ initPayload: __navState }} />
          <__OrbDocCoreConceptsStandardLibraryENDocAnalyticsView config={{ initPayload: __navState }} />
        </VStack>
      </UISlotComponent>
    </>
  );
}

export default OrbDocCoreConceptsStandardLibraryENOrbDocCoreConceptsStandardLibraryENPage;
